import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILURE,
} from 'store/categoryList/categoryListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getCategoryListDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY_LIST:
      return { ...state, loading: true };
    case GET_CATEGORY_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_CATEGORY_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getCategoryListDataReducer;
